import type { SheetOutletContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SheetWrapper/SheetWrapper';
import type { AnyFormApi } from '@tanstack/react-form';
import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

export function useRegisterSheetForm(form: AnyFormApi) {
  const { registerForm } = useOutletContext<SheetOutletContext>();

  useEffect(() => {
    registerForm(form);
    return () => registerForm(null);
  }, [form, registerForm]);
}
